import { Heading } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Heading/Heading';
import { Text } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Text/Text';
import { Link } from 'gatsby';
import React from 'react';
import { formatDate } from '../utils/formatDate';
import { formatSlug } from '../utils/formatSlug';

interface Props {
  newsDate: string | null;
  slug: string | null;
  title: string | null;
  isPremium?: boolean;
}

export const NewsListItem = ({ title, isPremium, newsDate, slug }: Props) => (
  <article className="group bg-white flex flex-col justify-between gap-xs p-3xl">
    {newsDate && (
      <Text size="text-s" color="text-secondary-text" font="font-light">
        {formatDate(newsDate)}
      </Text>
    )}
    <div>
      {title && (
        <Heading headingType="h6" as="h2">
          {title}
        </Heading>
      )}
    </div>
    <div>
      <Link to={formatSlug(slug ?? '', isPremium)}>
        <Text size="text-s" color="text-primary-main">
          Подробнее
        </Text>
      </Link>
    </div>
  </article>
);
